/**
 * The message an embedded booking page posts to its parent with its content height. The
 * website loader, public/booking-widget.js, is a static file that cannot import this, so it
 * repeats the string; bookingWidget.test.ts fails if the two drift apart. It is posted only to
 * the exact origin of a parent the clinic listed (embedParent.ts), never to "*", and still
 * carries only `{ type, height }`.
 */
export const BOOKING_RESIZE_MESSAGE = "bobdoc.booking.resize";
